// extracted by mini-css-extract-plugin
module.exports = {"container":"xS","disabled":"yS","subtotal":"zS","legal":"AS"};